import React, { useEffect, useState } from 'react';
import AdminAssets from './AdminAssets';
import AdminSidebar from './AdminSidebar';
import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
import axios from '../../utils/axiosInstance';
import { useAdmin } from '../../hooks/useAdmin';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const admin = useAdmin();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE}/admin/session`)
      .then((res) => {
        if (!res.data.loggedIn) {
          navigate('/admin');
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        navigate('/admin');
      });
  }, [navigate]);

  if (loading) return null;

  return (
    <div>
      <AdminAssets />
      <AdminSidebar />

      <section className="content">
        <div className="container-fluid">
          <div className="row clearfix">

          {admin?.permissions.includes("Enquiries") && (
            <DashboardCard
              to="/admin/enquiries"
              bg="bg-purple"
              icon="access_alarm"
              label="Enquiries"
            />
            )}

            {admin?.permissions.includes("Demo Batch Enquiries") && (
            <DashboardCard
              to="/admin/demoenquiries"
              bg="bg-purple"
              icon="access_alarm"
              label="Demo Batch Enquiries"
            />
            )}

            {admin?.permissions.includes("Batch Schedule") && (
            <DashboardCard
              to="/admin/batchschedule"
              bg="bg-cyan"
              icon="bookmark"
              label="Batch Schedule"
            />
            )}

            {admin?.permissions.includes("Free Placement Calls") && (
            <DashboardCard
              to="/admin/placementcalls"
              bg="bg-red"
              icon="bookmark"
              label="Free Placement Calls"
            />
            )}

            {admin?.permissions.includes("Recruiters Enquiries") && (
            <DashboardCard
              to="/admin/recruiters"
              bg="bg-cyan"
              icon="bookmark"
              label="Recruiters Enquiries"
            />
            )}

            {admin?.permissions.includes("Success Stories") && (
            <DashboardCard
              to="/admin/successstories"
              bg="bg-light-green"
              icon="help"
              label="Success Stories"
            />
            )}

            {admin?.permissions.includes("Blogs") && (
            <DashboardCard
              to="/admin/blogs"
              bg="bg-pink"
              icon="playlist_add_check"
              label="Blogs"
            />
            )}

            {admin?.permissions.includes("Users") && (
            <DashboardCard
              to="/admin/users"
              bg="bg-pink"
              icon="playlist_add_check"
              label="Users"
            />
            )}
           

          </div>
        </div>
      </section>
    </div>
  );
};

// 🔹 Reusable Card Component
const DashboardCard = ({ to, bg, icon, label }) => (
  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
    <Link to={to} style={{ textDecoration: 'none' }}>
      <div className={`info-box ${bg} hover-expand-effect`}>
        <div className="icon">
          <i className="material-icons">{icon}</i>
        </div>
        <div className="content">
          <div className="text">
            <h4>{label}</h4>
          </div>
        </div>
      </div>
    </Link>
  </div>
);

export default AdminDashboard;
